import { render } from "./ChoferesIndex.vue?vue&type=template&id=2b4ff874"
import script from "./ChoferesIndex.vue?vue&type=script&lang=js"
export * from "./ChoferesIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/cruds/ChoferesIndex.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2b4ff874"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2b4ff874', __exports__)) {
    api.reload('2b4ff874', __exports__)
  }
  
  module.hot.accept("./ChoferesIndex.vue?vue&type=template&id=2b4ff874", () => {
    api.rerender('2b4ff874', render)
  })

}


export default __exports__